import { ProductName } from 'Constants/products.constants';
import { ChangeFormValues } from 'Forms/ChangeForm/changeForm.types';
import { isTravelForm } from 'Utils/products.utils';
import {
  TRAVEL_COVERAGE_SINGLE,
  TRAVEL_COVERAGE_STANDARD,
  TRAVEL_COVERAGE_SUPER,
} from '../changeTravelForm.constants';
import { ChangeTravelFormValues } from '../changeTravelForm.types';

export const isCoverageTypeChangedFromStandardToSuper = (
  initialCoverageType: string,
  currentCoverageType: string,
): boolean =>
  initialCoverageType === TRAVEL_COVERAGE_SUPER &&
  currentCoverageType !== initialCoverageType;

export const isCoverageTypeChangedFromSuperToStandard = (
  initialCoverageType: string,
  currentCoverageType: string,
): boolean =>
  initialCoverageType === TRAVEL_COVERAGE_STANDARD &&
  currentCoverageType !== initialCoverageType;

export const isCoverageLengthUpgraded = (
  initialCoverageLength: string,
  currentCoverageLength: string,
): boolean => Number(currentCoverageLength) > Number(initialCoverageLength);

export const isCoverageLengthDowngraded = (
  initialCoverageLength: string,
  currentCoverageLength: string,
): boolean => Number(currentCoverageLength) < Number(initialCoverageLength);

export const isCoverageSingleOrFamilyUpgraded = (
  initialCoverageSingleOrFamily: string,
  currentCoverageSingleOrFamily: string,
): boolean =>
  initialCoverageSingleOrFamily === TRAVEL_COVERAGE_SINGLE &&
  currentCoverageSingleOrFamily !== initialCoverageSingleOrFamily;

export const needsCoverageConfirmation = (
  initialValues: ChangeTravelFormValues,
  currentValues: Omit<ChangeTravelFormValues, 'coverage'>,
): boolean => {
  return (
    isCoverageTypeChangedFromStandardToSuper(
      initialValues.coverageType,
      currentValues.coverageType,
    ) ||
    isCoverageLengthUpgraded(
      initialValues.coverageLength,
      currentValues.coverageLength,
    ) ||
    isCoverageSingleOrFamilyUpgraded(
      initialValues.coverageSingleOrFamily,
      currentValues.coverageSingleOrFamily,
    )
  );
};

export const isTravelCoverageUpgraded = (
  initialValues: ChangeFormValues,
  values: ChangeFormValues,
  productName: ProductName,
): boolean => {
  if (!isTravelForm(values) || !isTravelForm(initialValues)) {
    return false;
  }

  return (
    (productName === ProductName.TRAVEL &&
      isCoverageTypeChangedFromStandardToSuper(
        initialValues.coverageType,
        values.coverageType,
      )) ||
    isCoverageLengthUpgraded(
      initialValues.coverageLength,
      values.coverageLength,
    )
  );
};

export const isTravelCoverageDowngraded = (
  initialValues: ChangeFormValues,
  values: ChangeFormValues,
  productName: ProductName,
): boolean => {
  if (!isTravelForm(values) || !isTravelForm(initialValues)) {
    return false;
  }

  return (
    (productName === ProductName.TRAVEL &&
      isCoverageTypeChangedFromSuperToStandard(
        initialValues.coverageType,
        values.coverageType,
      )) ||
    isCoverageLengthDowngraded(
      initialValues.coverageLength,
      values.coverageLength,
    )
  );
};

export const addTravelFieldsToListOf30DaysChanges = (
  initialValues: ChangeTravelFormValues,
  values: ChangeTravelFormValues,
): string[] => {
  const {
    coverageType: initialCoverageType,
    coverageLength: initialCoverageLength,
  } = initialValues;
  const { coverageType, coverageLength } = values;
  const listOf30DaysChanges: string[] = [];

  if (
    isCoverageTypeChangedFromSuperToStandard(initialCoverageType, coverageType)
  ) {
    listOf30DaysChanges.push('dekning');
  }

  if (isCoverageLengthDowngraded(initialCoverageLength, coverageLength)) {
    listOf30DaysChanges.push('antall dager');
  }
  return listOf30DaysChanges;
};
